import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "slider-number" }
const _hoisted_2 = { class: "slider-number" }

import CategoriesField from '@/components/categories/CategoriesField.vue';
import StepsField from '@/components/action/StepsField.vue';
import { Action } from '@/models/action.model';
import { ref, PropType, watch, onMounted, computed } from 'vue';
import RichTextField from '@/components/common/RichTextField.vue';
import MediaList from '@/components/media/MediaList.vue';
import { MediaPurpose } from '@/models/media.model';
import { useStore } from 'vuex';
import { LabelsActions, LabelsState } from '@/stores/labels.store';
import { UserLabel } from '@/models/label.model';
import { ShiftCMSState } from '@/store';
import CategoryField from '../categories/CategoryField.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionContentForm',
  props: {
  modelValue: { type: Object as PropType<Action>, required: true },
},
  emits: ['update:modelValue', 'update:published'],
  setup(__props, { emit: __emit }) {

const store = useStore<ShiftCMSState & { ls: LabelsState }>();

const labels = computed<UserLabel[]>(() => store.state.ls.labels);

const props = __props;
const value = ref<Action>({ ...(props.modelValue || []) });

const emit = __emit;

const update = () => {
  emit('update:modelValue', value.value);
};
watch(
  () => props.modelValue,
  () => {
    Object.assign(value.value, props.modelValue);
  },
  { deep: true },
);

// const types = [
//   {
//     title: 'Action',
//     value: ActionType.Action,
//   },
//   {
//     title: 'Tips',
//     value: ActionType.Tips,
//   },
// ];

const togglePublished = async (published: boolean) => {
  if (value.value.id !== -1) {
    emit('update:published', { ...value.value, published: !published });
  }
  value.value.published = !published;
};

onMounted(() => {
  store.dispatch(LabelsActions.GetLabels);
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_slider = _resolveComponent("v-slider")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "mb-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "9" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: value.value.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value.value.title) = $event)),
                    onChange: update,
                    label: "Title",
                    required: "",
                    "hide-details": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "pt-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    block: "",
                    onClick: _cache[1] || (_cache[1] = () => togglePublished(value.value.published)),
                    color: !value.value.published ? 'success' : 'warning'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(value.value.published ? 'Un-publish' : 'Publish'), 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(CategoryField, {
            main: "",
            modelValue: value.value.mainCategory,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((value.value.mainCategory) = $event)),
            onChange: update,
            disabled: "",
            label: "Main Category"
          }, null, 8, ["modelValue"]),
          _createVNode(CategoriesField, {
            modelValue: value.value.categories,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((value.value.categories) = $event)),
            onChange: update
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_select, {
            modelValue: value.value.notRelevantForlabels,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((value.value.notRelevantForlabels) = $event)),
            label: "Not relevant for labels",
            multiple: "",
            clearable: "",
            class: "mb-4",
            "hide-details": "auto",
            style: { background: 'white' },
            items: labels.value.map((q) => ({ title: q.value, value: q }))
          }, {
            item: _withCtx(({ props }) => [
              _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title)
                ]),
                _: 2
              }, 1040)
            ]),
            _: 1
          }, 8, ["modelValue", "items"]),
          _createVNode(_component_v_slider, {
            label: "Difficulty",
            modelValue: value.value.difficulty,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((value.value.difficulty) = $event)),
            onEnd: update,
            min: 0,
            step: 1,
            max: 100
          }, {
            append: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(value.value.difficulty), 1)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_slider, {
            label: "Impact",
            modelValue: value.value.impact,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((value.value.impact) = $event)),
            onEnd: update,
            min: 0,
            step: 1,
            max: 100
          }, {
            append: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(value.value.impact), 1)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(RichTextField, {
            label: "Short description",
            height: 200,
            modelValue: value.value.shortDescription,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((value.value.shortDescription) = $event)),
            hint: "Used in stories when users choose their interest",
            onChange: update,
            media: __props.modelValue.media
          }, null, 8, ["modelValue", "media"]),
          _createVNode(RichTextField, {
            label: "Description",
            modelValue: value.value.description,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((value.value.description) = $event)),
            hint: "Used as the full text of the action",
            onChange: update,
            media: __props.modelValue.media
          }, null, 8, ["modelValue", "media"]),
          _createVNode(StepsField, {
            modelValue: value.value.steps,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((value.value.steps) = $event)),
            onChange: update,
            action: value.value
          }, null, 8, ["modelValue", "action"]),
          _createVNode(MediaList, {
            modelValue: value.value,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((value).value = $event)),
            onChange: update,
            required: [_unref(MediaPurpose).BackgroundImage, _unref(MediaPurpose).Main]
          }, null, 8, ["modelValue", "required"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})